import apiFetch from '../../apiFetch'

export default function (idAlimentacion, token) {
  return apiFetch({endPoint: `RegistroAlimentacion/deleteAlimentacion?idAlimentacion=` + idAlimentacion, method: 'GET', body: null, token: token})
}